import { StatusDetailSection } from "Status/StatusDetailSection";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";
import StatusDetailOptionsPanel from "./StatusDetailOptionsPanel";

const StatusDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.StatusDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <StatusDetailSection
            status={viewModel.status}
            mainArea={viewModel.mainArea}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <StatusDetailOptionsPanel
            status={viewModel.status}
            mainArea={viewModel.mainArea}
            data={viewModel.optionsPanel}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>;
};

export default StatusDetailApp;